import styled from "styled-components";
import { SIZE } from "constants/variables";

export const PersonnelSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: ${SIZE.max80};
`;

export const PersonnelSectionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max10};
  text-align: center;
`;

export const PersonnelSectionTitleWrapper = styled.div``;

export const PersonnelSectionSubtitleWrapper = styled.div``;

export const PersonnelSectionCarouselWrapper = styled.div`
  width: 100%;
`;
